
import React from 'react'

import ParticlesBg from 'particles-bg'
export default function WelcomeBackground() {
  return (
    <>
     <>
        <div>...</div>
        <ParticlesBg type="circle" bg={true} />
      </>
    </>
  )
}
